var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_277_2956)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.30141 0.0662874C7.37746 0.0228481 7.46353 -9.54242e-10 7.5511 -9.6544e-10C7.63868 -9.76637e-10 7.72475 0.0228481 7.80079 0.0662874L14.8485 4.09354C14.9255 4.13755 14.9896 4.20115 15.0341 4.27788C15.0787 4.35462 15.1022 4.44177 15.1022 4.5305L15.1022 5.25541C15.1022 7.47641 14.3787 9.63696 13.0411 11.41C11.7035 13.1831 9.82467 14.4721 7.68904 15.0819C7.59888 15.1076 7.50333 15.1076 7.41317 15.0819C5.2777 14.4718 3.39907 13.1827 2.06152 11.4097C0.723976 9.63672 0.000302393 7.47633 6.71926e-10 5.25541L5.79243e-10 4.5305C2.86213e-05 4.44177 0.0235104 4.35462 0.0680662 4.27788C0.112622 4.20115 0.176669 4.13755 0.253717 4.09354L7.30141 0.0662874ZM7.12019 10.7838L11.4676 5.34803L10.6823 4.71978L6.97521 9.35213L4.34944 7.16433L3.70508 7.93756L7.12019 10.7838Z",
    fill: "#12B85E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_277_2956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.4106,
    height: 15.4106,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiIcon);
export default __webpack_public_path__ + "static/media/LiIcon.5301fd4c22059a57274400631d51b8f9.svg";
export { ForwardRef as ReactComponent };